module.exports = { id: "magnifier", url: "/build/app/img/symbols.svg#magnifier", viewBox: "", toString: function() { return this.url; } };